import {vnTemplate} from "./vnTemplate";

declare var ko: any;

export class infoButton_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `
            <div data-bind="" style="position: relative">
                <!-- ko ifnot: buttonLabel -->
                    <button type="button" class="open-button icon i-help" data-bind="event: { click: onClickToggle }"></button>
                <!-- /ko -->
                <!-- ko if: buttonLabel -->
                    <button type="button" class="open-button" data-bind="text: buttonLabel, event: { click: onClickToggle }"></button>
                <!-- /ko -->
                <div class="tooltips-adv" data-bind="visible: isVisible, css: { 'is-overflow-escaped': isOverflowEscaped }" >      
                    <h3 class="tooltips-adv-title " data-bind="text: title"></h3>
                    <div class="tooltips-adv-content" data-bind="html: visibleContent"></div>
                    <button type="button" class="close-button icon i-x-after" data-bind="event: { click: onClickClose }"></button>
                </div>
            </div>
        `;
    }

    /**
     * @inheritDoc
     */
    protected getTemplateName(): string{

        return 'infoButton-template';
    }

    /**
     * @inheritDoc
     */
    protected getMainElementClasses(): Array<string>{

        return ['infoButton'];
    }

    /**
     * @inheritDoc
     */
    protected buildViewModel(): any {

        let self = this;

        return {
            isVisible: ko.observable(false),
            buttonLabel: ko.observable(''),
            title: ko.observable(''),
            content: ko.observable(''),
            visibleContent: ko.observable(''),
            // Used only when the button sits inside a clipping overflow ancestor
            // (e.g. .w-multi-dropdown); otherwise left false so shared tooltip CSS applies.
            isOverflowEscaped: ko.observable(false),
            onClickToggle: function(data, event){ self.toggleVisibility(this, event); },
            onClickClose: function(data, event){ self.hideTooltip(this, event); },
        };
    }

    //
    // Sets the button label.
    public setButtonLabel(buttonLabel){

        this.getTemplateViewModel().buttonLabel(buttonLabel);
    }

    //
    // Sets the title.
    public setTitle(title){

        this.getTemplateViewModel().title(title);
    }

    //
    // Sets the content.
    public setContent(content){

        this.getTemplateViewModel().content(content);
    }

    //
    // Hides tooltip.
    public hide(){

        this.hideTooltip(this.getTemplateViewModel());
    }

    //
    // Hide tooltip and clear any overflow-escape positioning.
    protected hideTooltip(viewModel, event?: Event): void{

        this.clearOverflowEscape(viewModel, event);
        viewModel.isVisible(false);
    }

    //
    // Toggle tooltip.
    protected toggleVisibility(viewModel, event?: Event): void{

        if(this.viewModel.lastButtonClicked && this.viewModel.lastButtonClicked !== this.idElement){

            let previous = this.viewModel[this.viewModel.lastButtonClicked];
            if(previous){
                this.hideTooltip(previous);
            }
        }

        if('' === viewModel.visibleContent() || viewModel.visibleContent() !== viewModel.content()){

            viewModel.visibleContent(viewModel.content());
        }

        let willShow = !viewModel.isVisible();
        viewModel.isVisible(willShow);

        if(willShow){
            this.escapeOverflowIfNeeded(viewModel, event);
        }else{
            this.clearOverflowEscape(viewModel, event);
        }

        this.viewModel.lastButtonClicked = this.idElement;
    }

    //
    // Multi-dropdown option lists use overflow scrolling, which clips absolute
    // tooltips and traps their stacking context. Escape only in that case.
    protected escapeOverflowIfNeeded(viewModel, event?: Event): void{

        let button = event && (event.currentTarget as HTMLElement);
        if(!button || typeof button.closest !== 'function' || !button.closest('.w-multi-dropdown')){
            this.clearOverflowEscape(viewModel, event);
            return;
        }

        let self = this;
        requestAnimationFrame(function(){
            self.positionEscapedTooltip(viewModel, button);
        });
    }

    protected positionEscapedTooltip(viewModel, button: HTMLElement): void{

        let tooltip = this.findTooltipElement(button);
        if(!tooltip || !viewModel.isVisible()){
            return;
        }

        viewModel.isOverflowEscaped(true);
        viewModel._escapedTooltipEl = tooltip;
        this.bindEscapeDismissListeners(viewModel);

        // Measure after the escaped class applies (position:fixed, transform cleared).
        requestAnimationFrame(function(){
            if(!viewModel.isVisible() || !tooltip){
                return;
            }

            let tipRect = tooltip.getBoundingClientRect();
            let btnRect = button.getBoundingClientRect();
            let gap = 8;
            let left = btnRect.left - tipRect.width - gap;
            let top = btnRect.top + (btnRect.height / 2) - (tipRect.height / 2);

            // Prefer left of the icon; fall back to the right if there is no room.
            if(left < gap){
                left = btnRect.right + gap;
            }

            left = Math.max(gap, Math.min(left, window.innerWidth - tipRect.width - gap));
            top = Math.max(gap, Math.min(top, window.innerHeight - tipRect.height - gap));

            // !important needed to override multi-dropdown absolute top/left rules.
            tooltip.style.setProperty('top', Math.round(top) + 'px', 'important');
            tooltip.style.setProperty('left', Math.round(left) + 'px', 'important');
        });
    }

    //
    // Fixed tooltips detach from their trigger on scroll; dismiss instead.
    protected bindEscapeDismissListeners(viewModel): void{

        if(viewModel._escapeDismissHandler){
            return;
        }

        let self = this;
        viewModel._escapeDismissHandler = function(event: Event){

            if(event && event.type === 'scroll'){
                let tooltip = viewModel._escapedTooltipEl as HTMLElement;
                let target = event.target as Node;
                // Allow scrolling inside the tooltip content without closing it.
                if(tooltip && target && tooltip.contains(target)){
                    return;
                }
            }

            self.hideTooltip(viewModel);
        };

        document.addEventListener('scroll', viewModel._escapeDismissHandler, true);
        window.addEventListener('resize', viewModel._escapeDismissHandler);
    }

    protected unbindEscapeDismissListeners(viewModel): void{

        if(!viewModel._escapeDismissHandler){
            return;
        }

        document.removeEventListener('scroll', viewModel._escapeDismissHandler, true);
        window.removeEventListener('resize', viewModel._escapeDismissHandler);
        viewModel._escapeDismissHandler = null;
    }

    protected clearOverflowEscape(viewModel, event?: Event): void{

        this.unbindEscapeDismissListeners(viewModel);

        if(viewModel.isOverflowEscaped){
            viewModel.isOverflowEscaped(false);
        }

        let tooltip = viewModel._escapedTooltipEl as HTMLElement;

        if(!tooltip){
            let button = event && (event.currentTarget as HTMLElement);
            tooltip = button ? this.findTooltipElement(button) : null;
        }

        if(tooltip){
            tooltip.style.removeProperty('top');
            tooltip.style.removeProperty('left');
        }

        viewModel._escapedTooltipEl = null;
    }

    protected findTooltipElement(button: HTMLElement): HTMLElement{

        if(!button || !button.parentElement){
            return null;
        }

        // Help button: sibling panel. Close button: the panel itself.
        if(button.classList.contains('close-button')){
            return button.closest('.tooltips-adv') as HTMLElement;
        }

        return button.parentElement.querySelector('.tooltips-adv') as HTMLElement;
    }
}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template.ts